import {
  mannequin1,
  mannequin2,
  mannequin3,
  mannequin4,
  mannequin5,
} from "../../assets";

export const productData = [
  {
    id: 1,
    title: "Pastwords",
    price: "24.99",
    image: mannequin1,
    quantity: 1,
  },
  {
    id: 2,
    title: "Authenti-late",
    price: "24.99",
    image: mannequin2,
    quantity: 1,
  },
  {
    id: 3,
    title: "Pastwords#1",
    price: "24.99",
    image: mannequin3,
    quantity: 1,
  },
  {
    id: 4,
    title: "Passwords Definition #2",
    price: "24.99",
    image: mannequin4,
    quantity: 1,
  },
  {
    id: 5,
    title: "Forget Passwords",
    price: "24.99",
    image: mannequin5,
    quantity: 1,
  },
  {
    id: 6,
    title: "Passwords Definition",
    price: "24.99",
    image: mannequin2,
    quantity: 1,
  },
];
